export default __webpack_public_path__ + "ny.png";